'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Field as FieldComponent } from '../field/index.js';
import { Input } from '../input/input.js';
import { Label } from '../label/label.js';

/**
 * Switch used to toggle options.
 *
 * @example
 * <Switch label="I agree" value="agree" />
 */
const Switch = forwardRef(function Switch({ 'data-size': size, children, className, description, label, position, style, ...rest }, ref) {
    return (jsxs(FieldComponent, { className: className, "data-position": position, "data-size": size, style: style, children: [jsx(Input, { type: 'checkbox', role: 'switch', ref: ref, ...rest }), !!label && jsx(Label, { weight: 'regular', children: label }), !!description && jsx("div", { "data-field": 'description', children: description })] }));
});

export { Switch };
